import Cookies from "universal-cookie";

// The token rides on the URL because a session cookie is third-party inside this
// iframe, and Safari blocks it outright — the frame would just show a login screen.
const ExternalFrame = (args) => {
    const cookies = new Cookies();
    const access_token = cookies.get("accessToken");

    const baseUrl = process.env.REACT_APP_EXTERNAL_FRAME_URL || 'http://localhost:9000';
    const path = args['path'] || '/';

    const params = new URLSearchParams();
    if (access_token) params.append("token", access_token);
    // Carry the boutique picked in the admin's own header, or the embedded page
    // falls back to the account's default and two store pickers disagree on one
    // screen. It is re-checked against the user's assignment server-side.
    const selectedStore = localStorage.getItem("selectedStore");
    if (selectedStore) params.append("store", selectedStore);

    const query = params.toString() ? `?${params}` : '';

    return (
        <iframe title="Report" width="100%" src={`${baseUrl}${path}${query}`} frameBorder={0}></iframe>
    )
}

export default ExternalFrame;
